import { getMonthlySummaryProjectsReportApi, getMonthlySummaryUsersReportApi } from "../api/reportApi";
import { failure, REPORT_REQUEST, request, success } from "./utilities";

export function getMonthlySummaryProjectsReportAction(params) {
    return(dispatch)=> {
        dispatch(request(REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_REQUEST));

        getMonthlySummaryProjectsReportApi(params)
        .then((response)=> {
            if(response.data.status === 1){
                dispatch(success(REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_SUCCESS, response.data.data));
            }else{
                dispatch(failure(REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_FAILURE, response.data.message));
            }           
        })
        .catch((error)=> {
            dispatch(failure(REPORT_REQUEST.GET_MONTHLY_SUMMARY_PROJECTS_REPORT_FAILURE, error?.response?.data?.title || error.message));
        });
    }
}

export function getMonthlySummaryUsersReportAction(params) {
    return(dispatch)=> {
        dispatch(request(REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_REQUEST));

        getMonthlySummaryUsersReportApi(params)
        .then((response)=> {
            if(response.data.status === 1){
                dispatch(success(REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_SUCCESS, response.data.data));
            }else{
                dispatch(failure(REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_FAILURE, response.data.message));
            }           
        })
        .catch((error)=> {
            dispatch(failure(REPORT_REQUEST.GET_MONTHLY_SUMMARY_USERS_REPORT_FAILURE, error?.response?.data?.title || error.message));
        });
    }
}